import React, { useEffect, useState } from "react";
import InsurancePatientInfoService from "./InsurancePatientInfoService";
import InsuranceDetailsService from "../insuranceDetails/insuranceDetailsService";
import "../registration/searchPopupDesign.css";

const insuranceService = new InsurancePatientInfoService();
const insuranceDetailsService = new InsuranceDetailsService();

const InsuranceRecordSelector = () => {
  const searchParams = new URLSearchParams(window.location.search);
  const patientId = searchParams.get("patientId");
  const inputTarget = "insptId";

  const [records, setRecords] = useState([]);
  const [insuranceNames, setInsuranceNames] = useState({});
  const [error, setError] = useState("");

  useEffect(() => {
    if (!patientId) {
      setError("❌ No patient ID provided.");
      return;
    }

    const fetchRecords = async () => {
      try {
        const data = await insuranceService.getByPatientId(patientId);
        const validRecords = Array.isArray(data) ? data : [];
        setRecords(validRecords);

        const nameMap = {};
        await Promise.all(
          validRecords.map(async (rec) => {
            const insId = rec.insId;
            if (insId && !nameMap[insId]) {
              try {
                const insDetail = await insuranceDetailsService.getInsuranceDetailById(insId);
                nameMap[insId] = insDetail.insName || "Unnamed Insurance";
              } catch (err) {
                nameMap[insId] = "Unknown Insurance";
              }
            }
          })
        );
        setInsuranceNames(nameMap);
      } catch (err) {
        console.error("Error fetching insurance records:", err);
        setError("❌ Failed to fetch insurance records.");
      }
    };

    fetchRecords();
  }, [patientId]);

  const handleSelect = (record) => {
    const id = record.insptId;
    const insId = record.insId;
    const insuranceName = insuranceNames[insId] || "Unknown Insurance";
    const subscriber = record.subscriber || "N/A";

    if (!id) {
      alert("❌ No valid insptId found.");
      return;
    }

    const name = `${insuranceName} — Subscriber: ${subscriber} — ID: ${id}`;

    window.opener?.postMessage(
      {
        inputTarget,
        value: id,
        displayName: name,
      },
      "*"
    );

    window.close();
  };

  return (
    <div className="popup-overlay">
      <div className="popup-content">
        <h2>Select Insurance Record</h2>

        {error && <p style={{ color: "red" }}>{error}</p>}

        <ul className="results-list">
          {records.length === 0 && !error && <li>No records found.</li>}
          {records.map((rec, i) => {
            const insId = rec.insId;
            const insName = insuranceNames[insId] || "Loading...";
            return (
              <li key={i} onClick={() => handleSelect(rec)}>
                {insName} — Subscriber: {rec.subscriber || "N/A"} — ID: {rec.insptId}
              </li>
            );
          })}
        </ul>

        <button className="close-button" onClick={() => window.close()}>
          Close
        </button>
      </div>
    </div>
  );
};

export default InsuranceRecordSelector;
